export default class OfferCanvas {
  // eslint-disable-next-line no-useless-constructor
  constructor(private degrees: number, private isOpenOffer: boolean) {}

  public draw(canvas: HTMLCanvasElement): void {
    canvas.height = canvas.width

    const ctx = canvas.getContext('2d')!
    const chartX = canvas.width / 2
    const chartY = canvas.height / 2
    const chartRadius = canvas.width / 2 - 6

    ctx.lineCap = 'round'

    ctx.beginPath()
    ctx.arc(chartX, chartY, chartRadius, 0, Math.PI * 2)
    ctx.fillStyle = '#2f2f2f'
    ctx.fill()
    ctx.strokeStyle = '#b7b6b9'
    ctx.lineWidth = 12
    ctx.stroke()

    const xStart = chartX + Math.cos(Math.PI) * chartRadius
    const yStart = chartY + Math.sin(Math.PI) * chartRadius
    const xEnd = chartX + Math.cos(2 * Math.PI) * chartRadius
    const yEnd = chartY + Math.sin(2 * Math.PI) * chartRadius

    const gradient = ctx.createLinearGradient(xStart, yStart, xEnd, yEnd)

    if (this.isOpenOffer) {
      gradient.addColorStop(0, '#2AA9CD')
      gradient.addColorStop(1, '#1CD77C')
    } else {
      gradient.addColorStop(0, '#666666')
      gradient.addColorStop(1, '#666666')
    }

    ctx.beginPath()
    ctx.strokeStyle = gradient
    ctx.lineWidth = 12
    if (this.degrees < 360) {
      ctx.arc(
        chartX,
        chartY,
        chartRadius,
        Math.PI * 1.5,
        (Math.PI / 180) * (180 + this.degrees) - Math.PI * 1.5 + 0.0001  // it fixes behavior when angle = 0
      )
      ctx.stroke()
    }
    else {
      ctx.arc(
        chartX,
        chartY,
        chartRadius,
        Math.PI * 1.5,
        Math.PI - Math.PI * 1.5  // chart filled when angle = 360
      )
      ctx.stroke()
    }
  }
}
